import { useEffect } from "react";
import axios from "axios";
import { computeIsCreator } from "../utils/onboarding";

const API_URL = process.env.REACT_APP_API_URL;

export const useSyncUser = (intervalMs = 5 * 60 * 1000) => {
  useEffect(() => {
    const syncUser = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await axios.get(`${API_URL}/users/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const user = res.data;

        const userLite = {
          id: user._id,
          name: user.name,
          email: user.email,
          role: user.role,
          empresa: user.empresa,
          foto: user.foto || null,
          servicioActivo: user.servicioActivo || null,
          servicioInicio: user.servicioInicio || null,
          onboarding: user.onboarding || {},
          dashboardLayout: user.dashboardLayout || {},
          isCreator: computeIsCreator(user),
          emailVerified: user.emailVerified,
          policyAcceptance: user.policyAcceptance || null,
        };

        localStorage.setItem("user", JSON.stringify(userLite));
        window.dispatchEvent(new Event("user-sync"));

        // Sincronizar servicioActivo entre dispositivos
        const localServicio = JSON.parse(localStorage.getItem("servicioActivo"));
        if (user.servicioActivo) {
          const serverCronogramaId = user.servicioActivo.toString();
          if (!localServicio || localServicio.cronogramaId !== serverCronogramaId) {
            // Otro dispositivo inició un servicio — replicar en este
            const inicio = user.servicioInicio
              ? new Date(user.servicioInicio).getTime()
              : Date.now();
            localStorage.setItem(
              "servicioActivo",
              JSON.stringify({ cronogramaId: serverCronogramaId, inicio, acumuladoSegundos: 0 }),
            );
          }
        } else {
          // El servidor no tiene servicio activo — limpiar cache local
          if (localServicio) {
            localStorage.removeItem("servicioActivo");
          }
        }
      } catch (err) {
        console.error("Error sincronizando usuario:", err);
      }
    };

    syncUser();

    const interval = setInterval(syncUser, intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);
};
